/**
 * @desc Controller for the csUniversalSearch directive
 */
;(function () {
  angular
    .module('contrast.search')
    .controller('csUniversalSearchCtrl', csUniversalSearchCtrl)

  function csUniversalSearchCtrl(
    $,
    $location,
    $timeout,
    PromiseService,
    ErrorService,
    SearchService,
    GoogleAnalyticsService,
    SearchFactory,
    searchTypes
  ) {
    'ngInject'

    var vm, resultSelected, searchCleared

    this.$onInit = function () {
      vm = this
      resultSelected = false
      searchCleared = false

      angular.extend(vm, {
        loadingResults: false,
        searchOpen: false,
        searchResultsOpen: false,
        searchMinLength: 2,
        searchTypes: searchTypes
      })

      angular.extend(vm, {
        searchFocus: searchFocus,
        searchBlur: searchBlur,
        searchValue: searchValue,
        clearSearch: clearSearch,
        getResults: getResults,
        selectResult: selectResult,
        format: format,
        getSecondaryInfo: getSecondaryInfo,
        hasSearchValue: hasSearchValue
      })
    }

    var lastSearch = null,
      _searchTerm = '',
      _lastQuery

    function searchFocus() {
      if (resultSelected) {
        resultSelected = false
        return
      }
      vm.searchOpen = true
    }

    function searchBlur() {
      $timeout(function () {
        if (!searchCleared) {
          vm.searchOpen = false
        }
        searchCleared = false
      }, 300)
    }

    function searchValue(newSearchValue) {
      if (!arguments.length) {
        return _searchTerm
      }

      if (newSearchValue !== _searchTerm) {
        _searchTerm = newSearchValue
      }

      return _searchTerm
    }

    function clearSearch() {
      searchCleared = true
      vm.searchValue = ''
      $timeout(function () {
        $('.search-input').focus()
      }, 10)
    }

    function getResults(q) {
      if (
        !q ||
        q.length < vm.searchMinLength ||
        resultSelected ||
        !vm.searchOpen
      ) {
        resultSelected = false
        return
      }

      if (lastSearch) {
        PromiseService.cancelPromise(lastSearch)
      }

      _lastQuery = q
      lastSearch = SearchFactory.getSearchResults(q)

      var gaEvent = {
        category: 'Universal search',
        action: q
      }
      GoogleAnalyticsService.sendEvent(gaEvent)

      return lastSearch.then(handleSuccess, handleFailure)
    }

    function handleSuccess(response) {
      return SearchService.transformSearchResults(response.data.results)
    }

    function handleFailure(response) {
      ErrorService.processError(response)
    }

    function selectResult(result) {
      if (!result) {
        return
      }

      resultSelected = true
      var path = SearchService.getResultLink(result)
      if (path) {
        const urlSegments = path.split('?')
        $location.path(urlSegments[0])
        if (urlSegments[1]) {
          const searchParams = urlSegments[1] ? urlSegments[1].split('&') : []
          searchParams.forEach((paramValuePair) => {
            const paramValue = paramValuePair.split('=')
            $location.search(paramValue[0], paramValue[1])
          })
        }
      }
    }

    function format(result) {
      if (!result) {
        return undefined
      }
      return _lastQuery
    }

    function getSecondaryInfo(result) {
      if (!result) {
        return undefined
      }
      return SearchService.getSecondaryInfo(result)
    }

    function hasSearchValue() {
      return _searchTerm != '' && _searchTerm != null
    }
  }
})()
